import { render, staticRenderFns } from "./Payment.vue?vue&type=template&id=7c006f80&scoped=true&lang=html&"
import script from "./Payment.vue?vue&type=script&lang=js&"
export * from "./Payment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c006f80",
  null
  
)

export default component.exports